import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { WebPageShell } from '../components/common/WebPageShell';
import { useRoute } from '@react-navigation/native';
import { WalletContent } from '../components/wallet/WalletContent';
import { useTheme } from '../context/ThemeContext';

/** The children's wallets - web layout with the sidebar shell. */
export function WalletScreen() {
  const { colors } = useTheme();
  // Home's "Pay now" opens straight on the Pay tab.
  const route = useRoute<any>();
  const initialTab = route?.params?.tab === 'pay' ? 'pay' : 'wallet';

  return (
    <WebPageShell title="Wallet">
      <View style={styles.header}>
        <Text style={[styles.title, { color: colors.textPrimary }]}>Wallet</Text>
        <Text style={[styles.subtitle, { color: colors.textSecondary }]}>
          Balance, statement and cards for each child - and top-ups.
        </Text>
      </View>
      <WalletContent initialTab={initialTab} />
    </WebPageShell>
  );
}

const styles = StyleSheet.create({
  header: { marginBottom: 16 },
  title: { fontSize: 22, fontWeight: '800' },
  subtitle: { fontSize: 13, marginTop: 4 },
});
